const env=process.env.NODE_ENV;
const advertisement = {
  development:'http://sdk-test.anbokeji.net/adv/index.js',
  production:'http://sdk.anbokeji.net/adv/index.js'
}

export default advertisement[env]


// WEBPACK FOOTER //
// ./src/config/anboUrl.js